import { render, staticRenderFns } from "./campusMicroMuseum.vue?vue&type=template&id=339e8d9a&scoped=true&"
import script from "./campusMicroMuseum.vue?vue&type=script&lang=js&"
export * from "./campusMicroMuseum.vue?vue&type=script&lang=js&"
import style0 from "./campusMicroMuseum.vue?vue&type=style&index=0&id=339e8d9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339e8d9a",
  null
  
)

export default component.exports